// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserActivityInputDataAnyOf } from './userActivityInputDataAnyOf';

export type UserActivityInputData = UserActivityInputDataAnyOf | null;
